import { Component } from '@angular/core';
import { ALL_IMPORTS } from '@shared/common-imports';

@Component({
  selector: 'app-auth-layout',
  standalone: true,
  imports: [...ALL_IMPORTS],
  templateUrl: './auth-layout.component.html',
  styleUrls: ['./auth-layout.component.scss'],
})
export class AuthLayoutComponent {}
